import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocatorBackendServer extends BaseBackend {

  getServiceCenters(params): Observable<any> {
    return this.get(`/locator`, { params });
  }

}
